// Skip-to-main-content link. Visible only when focused (see .skip-link in index.css).
export const SkipLink = () => (
  <a href="#main-content" className="skip-link" data-testid="skip-link">
    Skip to main content
  </a>
);
